import axios from "axios";
import store from "../redux/store";
import { setUser } from "../redux/UserSlice";

const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refresh_token");
    if (!refreshToken) throw new Error("No refresh token available");

    const response = await axios.post("/authentication/refresh-token", {
      refresh_token: refreshToken,
    });

    const newAccessToken = response.data.access_token;

    store.dispatch(setUser({ accessToken: newAccessToken }));

    return newAccessToken;
  } catch (error) {
    console.error("Ошибка обновления access токена:", error);
    throw error;
  }
};

const isAuthLoginRequest = (url?: string) =>
  !!url && url.includes("/authentication/login");

axios.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.UserSlice.accessToken;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config || {};

    // Ошибки логина (неверный пароль/токен) не должны редиректить / рефрешиться
    if (isAuthLoginRequest(originalRequest.url)) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newAccessToken = await refreshAccessToken();
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axios(originalRequest);
      } catch (err) {
        console.error("Redirecting to login due to token refresh failure");
        window.location.href = "/sign-in";
      }
    }

    return Promise.reject(error);
  }
);
